import React from "react";
import clsx from "clsx";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { lynxDropdownStyles } from "./LynxDropdownStyles";
import { LynxInput } from "components/LynxInput/LynxInput";
import { ReactComponent as FilterDownArrow } from "icons/FilterDownArrow.svg";
import { Typography } from "@material-ui/core";
import { LynxDropdownProps } from "./LynxDropdownProps";
import { observer } from "mobx-react";

export const LynxDropdown = observer(function LynxDropdown({
    label,
    multiple = true,
    optionState,
    stateSetMethod,
    title,
    options,
    isCustomizable,
    customClass,
    customInputClass,
    customLabelClass,
}: LynxDropdownProps) {
    const classes = lynxDropdownStyles({ isCustomizable });

    return (
        <FormControl
            className={clsx(classes.formControl, classes.noLabel, customClass)}
        >
            {label && (
                <Typography className={classes.label + " " + customLabelClass}>
                    {label}
                </Typography>
            )}

            <Select
                multiple={multiple}
                IconComponent={FilterDownArrow}
                displayEmpty
                value={optionState}
                onChange={stateSetMethod}
                input={<LynxInput className={customInputClass} />}
                renderValue={(selected) => {
                    if ((selected as string[]).length === 0) {
                        return <Typography>{title}</Typography>;
                    }
                    return (selected as string[]).join(", ");
                }}
                MenuProps={{
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                    getContentAnchorEl: null,
                    style: {
                        marginTop: 1,
                        maxHeight: 300,
                    },
                }}
            >
                {options.map((option: string) => (
                    <MenuItem
                        className={classes.menuItem}
                        classes={{ selected: classes.selected }}
                        key={option}
                        value={option}
                    >
                        {option}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
});
